import * as React from "react";
import { Alert } from "@picklebet/ui";
import { Button } from "@picklebet/ui";
import * as support from "@/utilities/support";
import { navigate } from "@/utilities/navigate";
import { useShellStore } from "@/features/shell/stores/shellStore";
import { SupportLink } from "@/features/shell/components/shared/SupportLink";

import * as styles from "./Auth.module.scss";

type ErrorsProps = {
  type: string;
  message?: string;
};

const Errors = ({ type, message = "" }: ErrorsProps) => {
  const setModal = useShellStore((state) => state.setModal);

  let content = <>{message}</>;
  let actions = null;

  if (type === "user.closed") {
    content = (
      <>
        <>Your account has been closed.</>
      </>
    );
  }

  if (type === "password.reset.required") {
    content = (
      <>
        Your account has been temporarily locked due to multiple failed login
        attempts.
      </>
    );

    actions = (
      <Button
        onClick={() => {
          setModal(null);
          navigate("/forgot-password");
        }}
        variant="danger"
        size="sm"
      >
        Reset Password
      </Button>
    );
  }

  if (type === "captcha.puzzle.failed") {
    actions = (
      <Button onClick={() => support.openWithChat()} variant="danger" size="sm">
        Contact Support
      </Button>
    );
  }

  if (type === "{excluded.persons.registry.match}") {
    content = (
      <span>
        Account could not be created. Please contact{" "}
        <SupportLink
          hideChevron
          openLiveChat
          title="have a chat with our Customer Support"
          className={styles.supportLink}
        >
          Support
        </SupportLink>
        .
      </span>
    );
  }

  return (
    <Alert color="danger" actions={actions}>
      {content}
    </Alert>
  );
};

export { Errors };
